import * as React from 'react';

import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';

import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { Translation, useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { RATING_FILTER, ReviewAndRating } from '@/services/faq/faq.types';
import useDeleteReviewAndRatings from '../hooks/useDeleteReviewAndRatings';
import { getColumns } from './Column';

export function ReviewAndRatingsTable({
  data,
  pagination,
  loading,
}: {
  data: ReviewAndRating[];
  pagination: Pagination;
  loading: boolean;
}) {
  const { locale, t } = useDynamicLocale();
  const { openConfirmation } = useConfirmationStore();
  const { mutateAsyncReviewAndRatingsStatus } = useDeleteReviewAndRatings();
  const columns = React.useMemo(
    () => getColumns(t, locale, openConfirmation, mutateAsyncReviewAndRatingsStatus),
    [t, locale, openConfirmation, mutateAsyncReviewAndRatingsStatus],
  );
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const { table, ratingsFilter, onRatingsFilterChange } = useDataTable({
    data: data,
    columns,
    pageCount: pageCount,
    initialState: {
      sorting: [{ id: 'sn', desc: true }],
    },
    meta: {
      title: <Translation id="faq.reviewRating.table.title" />,
      totalPage: pagination.totalItems,
      loading: loading,
    },
    getRowId: (originalRow) => String(originalRow.sn),
    shallow: false,
    clearOnDefault: true,
  });

  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar
          ratingsFilter={ratingsFilter as RATING_FILTER}
          onRatingsFilterChange={onRatingsFilterChange}
        />
      </DataTable>
    </>
  );
}
